// React
import React from "react";
import PropTypes from "prop-types";

const LanguageItem = ({ active, onClick, text, ...props }) => {
  const bannerImg = require("../../../../../../assets/img/blank.gif");
  return (
    <li className={active ? "active" : ""} style={{ cursor: 'pointer' }}>
      <a onClick={onClick}>
        <span>
          &nbsp;
          {text}
        </span>
      </a>
    </li>
  );
};

LanguageItem.defaultProps = {
  active: false,
  iconClass: "",
  onClick: () => { }
};

LanguageItem.propTypes = {
  active: PropTypes.bool,
  iconClass: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired
};

export default LanguageItem;
